import { atom } from "recoil";

export const menuOpenAtom = atom<boolean | undefined>({
  default: undefined,
  key: "menuOpen",
});
